










































import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class LineItemView extends Vue {
  @Prop() private lineItem: any;
}
